import type { AclRoleResourceVM } from '~/composables/useRequest/requests/data-contracts';


export default async function getAllNrm3RoleResources(
  aclRoleId: number,
  filter = 'nrm3.*',
  query: {
    /**
         * @min 1
         * @max 500
         * @example 10
         */
    limit?: number;
    /**
     * @min 0
     * @example 0
     */
    page?: number;
  } = {},
): Promise<AclRoleResourceVM[]> {
  const { aclRole } = useRequest();
  const data: {
    list: AclRoleResourceVM[];
    total: number;
  } = { list: [], total: 0 };

  try {
    const { payload: { list, total } } = await aclRole
      .aclRoleResourceControllerGetAllPaginatedEntities(aclRoleId, {
        ...query,
        limit: 100,
        page: query.page || 0,
        filter: [
          {
            field: 'acl-role-resource.resource',
            operation: 'like',
            value: filter,
          },
        ],
      });

    data.list = list;
    data.total = total;
  } catch {}

  if (((query.page || 0) + 1) * (query.limit || 100) < data.total) {
    try {
      const list = await getAllNrm3RoleResources(aclRoleId, filter, {
        ...query,
        page: (query.page || 0) + 1,
      });

      return data.list.concat(list);
    } catch {
      return [];
    }
  }

  return data.list;
}
